module.exports = __webpack_public_path__ + "static/media/Hold Me Down - Instrumental Version.7dda8bb4.jpg";